"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'spotify';
// Access token
exports.SET_ACCESS_TOKEN = exports.namespace + "/SET_ACCESS_TOKEN";
exports.SPOTIFY_UNAUTHORIZED_ERROR = exports.namespace + "/SPOTIFY_UNAUTHORIZED_ERROR";
// Playback
exports.TRANSFER_PLAYBACK = exports.namespace + "/TRANSFER_PLAYBACK";
exports.PLAYBACK_PLAY = exports.namespace + "/PLAYBACK_PLAY";
exports.PLAYBACK_PAUSE = exports.namespace + "/PLAYBACK_PAUSE";
exports.PLAYBACK_SEEK = exports.namespace + "/PLAYBACK_SEEK";
exports.SET_PLAYBACK_SEEK_TIME = exports.namespace + "/SET_PLAYBACK_SEEK_TIME";
// Album
exports.FETCH_BRAND_ALBUMS = exports.namespace + "/FETCH_BRAND_ALBUMS";
exports.FETCH_IS_SAVED_ALBUM = exports.namespace + "/FETCH_IS_SAVED_ALBUM";
exports.SAVE_ALBUM = exports.namespace + "/SAVE_ALBUM";
exports.REMOVE_ALBUM = exports.namespace + "/REMOVE_ALBUM";
// Player
exports.FETCH_PLAYER_STATE = exports.namespace + "/FETCH_PLAYER_STATE";
// Profile
exports.FETCH_PROFILE = exports.namespace + "/FETCH_PROFILE";
//# sourceMappingURL=constants.js.map